import { render, staticRenderFns } from "./authorDialog.vue?vue&type=template&id=d4fb32f8&scoped=true"
import script from "./authorDialog.vue?vue&type=script&lang=js"
export * from "./authorDialog.vue?vue&type=script&lang=js"
import style0 from "./authorDialog.vue?vue&type=style&index=0&id=d4fb32f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fb32f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4fb32f8')) {
      api.createRecord('d4fb32f8', component.options)
    } else {
      api.reload('d4fb32f8', component.options)
    }
    module.hot.accept("./authorDialog.vue?vue&type=template&id=d4fb32f8&scoped=true", function () {
      api.rerender('d4fb32f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/authorDialog.vue"
export default component.exports